import React from 'react';
import PropTypes from 'prop-types';

import { AnimateFrom } from '@mlb/react-patterns/components/AnimatedModal/animatedModal.types.ts';
import Button from '@mlb/react-patterns/components/Button/button.tsx';

import { useDictionary } from 'bdvp-common/src/hooks/config';
import { useKeyPress } from 'bdvp-common/src/hooks';
import { keyConstants } from 'bdvp-common/src/utils';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import {
    Modal,
    ModalFooter,
} from './FilterModal.style';

const { FILTER_MODAL_NAME } = modalConstants;
const { TAB } = keyConstants;
const keysToTrack = [TAB];

const FilterModal = ({
    onClosedHandler,
    onOpenedHandler,
    onAddFiltersHandler,
    children,
    applyFilterButtonRef,
    closeButtonRef,
    hideFooter,
    clearAllButton,
    isFreeTextSearchEnabled,
}) => {

    const dictionary = useDictionary();

    const keysTrackingCB = (event) => {

        if (event.target === applyFilterButtonRef.current) {

            event.preventDefault();
            closeButtonRef.current.focus();

        }

    };

    const shiftKeyTrackingCB = (event) => {

        if (event.target === closeButtonRef.current) {

            event.preventDefault();
            applyFilterButtonRef.current.focus();

        }

    };

    const callBackProps = {
        cb: keysTrackingCB,
        shiftCB: shiftKeyTrackingCB,
    };

    useKeyPress(keysToTrack, callBackProps);

    const footer = (
        <ModalFooter hide={hideFooter}>
            <Button
                label={dictionary.apply_filters_text ?? 'Apply Filters'}
                size={'md'}
                styleName={'link-blue'}
                handlers={ onAddFiltersHandler }
                ref={ applyFilterButtonRef }
            />
        </ModalFooter>
    );


    return (
        <Modal
            name={FILTER_MODAL_NAME}
            width={'100%'}
            height={'99%'}
            overlay={true}
            animate={true}
            animateFrom={AnimateFrom.BOTTOM}
            animationDuration={0.3}
            position={{
                bottom: 0,
                left: 0,
            }}
            handlers={
                {
                    onClosed: onClosedHandler,
                    onOpened: onOpenedHandler,
                }
            }
            headerTitle={isFreeTextSearchEnabled ? dictionary.filters ?? 'Filters' : dictionary.video_search ?? 'Video Search'}
            headerButton={clearAllButton}
            modalFooter = {footer}
            closeButtonRef={closeButtonRef}
            closeButtonRight={true}
        >
            {children}
        </Modal>
    );

};

FilterModal.propTypes = {
    onClosedHandler: PropTypes.func.isRequired,
    onOpenedHandler: PropTypes.func.isRequired,
    onAddFiltersHandler: PropTypes.shape().isRequired,
    children: PropTypes.node.isRequired,
    applyFilterButtonRef:  PropTypes.shape().isRequired,
    closeButtonRef: PropTypes.shape().isRequired,
    hideFooter: PropTypes.bool,
    clearAllButton: PropTypes.node.isRequired,
    isFreeTextSearchEnabled: PropTypes.bool,
};

FilterModal.defaultProps = {
    hideFooter: false,
    isFreeTextSearchEnabled: false,
};

export default FilterModal;
